import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Lock } from "@phosphor-icons/react";
import client from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { BrandMark } from "../components/BrandMark";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { login } = useAuth();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    if (password !== confirm) { toast.error("Passwords don't match."); return; }
    setLoading(true);
    try {
      const r = await client.post("/auth/reset-password", { token, password });
      login(r.data.token, r.data.user);
      toast.success("Password set. You're signed in.");
      nav("/", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "This link is invalid or expired.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBFAF7] p-8" data-testid="reset-panel">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
        <div className="mb-6"><BrandMark logoSize={38} textClass="text-[#4A0000]" textSize="text-2xl" /></div>
        <h2 className="font-bold text-4xl mb-1 tracking-tight">Set your password</h2>
        <p className="text-sm text-[#5C5A58] mb-6">Choose a password for your Reelty account.</p>
        {!token ? (
          <p className="text-[#B4472E]" data-testid="reset-no-token">This reset link is missing its token. Ask an admin to resend it.</p>
        ) : (
          <form onSubmit={submit} className="space-y-3" data-testid="reset-form">
            <Input data-testid="reset-password-input" type="password" required placeholder="New password (min 8 chars)"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="h-12 bg-white border-[#E9DDC6] focus-visible:ring-[#B08D57]" />
            <Input data-testid="reset-confirm-input" type="password" required placeholder="Confirm password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="h-12 bg-white border-[#E9DDC6] focus-visible:ring-[#B08D57]" />
            <Button data-testid="reset-submit-button" type="submit" disabled={loading}
              className="w-full h-12 bg-[#4A0000] hover:bg-[#5C1A1A] text-white">
              <Lock size={18} weight="duotone" className="mr-1" />{loading ? "Saving…" : "Save password & sign in"}
              {!loading && <ArrowRight size={18} className="ml-1" />}
            </Button>
          </form>
        )}
      </motion.div>
    </div>
  );
}
